import _ from 'lodash';
import axios from 'axios';
import configService from '@/services/configService';
import utils from '@/helper/utils';

export default {
  async getSignedUrl({ filename, filetype }) {
    return axios
      .get(`${configService.get('apiUrl')}/video-upload/get-signed-url?filename=${filename}&filetype=${filetype}`, {})
      .then(response => {
        return response.data;
      })
      .catch(e => {
        throw e;
      });
  },
  async uploadVideo({ url, file }) {
    const instance = axios.create();
    delete instance.defaults.headers.common.Authorization;
    const config = {
      method: 'put',
      url,
      headers: {
        'Content-Type': 'video/mp4'
      },
      data: file
    };
    return instance(config)
      .then(response => {
        return response.data;
      })
      .catch(e => {
        throw e;
      });
  },
  async listVideos({ query = {} } = {}) {
    const pickedQuery = _.pick(query, [
      'q',
      'page',
      'page_size',
      'filter',
      'search',
      'searchkey',
      'startdate',
      'enddate'
    ]);
    let url = `${configService.get('apiUrl')}/video-upload`;
    if (pickedQuery) {
      url += `?${utils.toQueryStrings(pickedQuery)}`;
    }

    return axios
      .get(url, {})
      .then(response => {
        return response.data;
      })
      .catch(e => {
        throw e;
      });
  },

  async getOne({ id }) {
    return axios
      .get(`${configService.get('apiUrl')}/video-upload/${id}`, {})
      .then(response => {
        return response.data;
      })
      .catch(e => {
        throw e;
      });
  },

  async getApprovedVideo() {
    return axios
      .get(`${configService.get('apiUrl')}/video-upload/approvedVideo`, {})
      .then(response => {
        return response.data;
      })
      .catch(e => {
        throw e;
      });
  },
  async deleteOne({ id }) {
    return axios
      .delete(`${configService.get('apiUrl')}/video-upload/${id}`)
      .then(response => {
        return response.data;
      })
      .catch(e => {
        throw e;
      });
  },

  async postOne({ video } = {}) {
    return axios
      .post(`${configService.get('apiUrl')}/video-upload/`, video)
      .then(response => {
        return response.data;
      })
      .catch(e => {
        throw e;
      });
  },

  async getOne({ id }) {
    return axios
      .get(`${configService.get('apiUrl')}/video-upload/${id}`, {})
      .then(response => {
        return response.data;
      })
      .catch(e => {
        throw e;
      });
  },

  async patchOne({ id, newVideo }) {
    return axios
      .patch(`${configService.get('apiUrl')}/video-upload/${id}`, newVideo)
      .then(response => {
        return response.data;
      })
      .catch(e => {
        throw e;
      });
  }
};
